<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<button
					type="button"
					class="btn-close"
					(click)="filtersClose()"
					data-bs-dismiss="modal"
					aria-label="Close"
				></button>
			</div>
			<div class="modal-body">
				<div class="row g-2 mb-4">
					<div class="form-floating col-md">
						<input
							type="date"
							class="form-control"
							name="date_from"
							[(ngModel)]="filters.date_from"
							id="date_from"
						/>
						<label for="date_from" class="form-label">Od</label>
					</div>
					<div class="form-floating col-md">
						<input
							type="date"
							class="form-control"
							name="date_to"
							[(ngModel)]="filters.date_to"
							id="date_to"
						/>
						<label for="date_to" class="form-label">Do</label>
					</div>
				</div>
				<div class="mb-3">
					<label class="form-label" for="driverKinds">Rodzaj kierowcy</label>
					<ng-select
						id="driverKinds"
						name="driverKinds"
						[(ngModel)]="filters.driverKinds"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of driverKinds" [value]="item.id">{{ item.name }} </ng-option>
					</ng-select>
				</div>

				<div class="mb-3">
					<label class="form-label" for="drivers">Kierowca</label>
					<ng-select
						id="drivers"
						name="drivers"
						[(ngModel)]="filters.drivers"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of drivers" [value]="item.id">{{ item.name }} </ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="settlementBonusName">Dodatek/Potrącenie</label>
					<ng-select
						id="settlementBonusName"
						name="settlementBonusName"
						[(ngModel)]="filters.settlementBonusName"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of settlementBonusNames" [value]="item.id">{{
							item.name
						}}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label class="form-label" for="vehicles">Rodzaj pojazdu</label>
					<ng-select
						id="vehicles"
						name="vehicles"
						[(ngModel)]="filters.vehicles"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of vehicles" [value]="item.id">{{ item.name }} </ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="confirm">Zatwierdzone</label>
					<ng-select
						id="confirm"
						name="confirm"
						[(ngModel)]="filters.confirm"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of confirm" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="workshop">Zatwierdzone warsztat</label>
					<ng-select
						id="workshop"
						name="workshop"
						[(ngModel)]="filters.workshop"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of workshop" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="settlementKind">Rodzaj uznania</label>
					<ng-select
						id="settlementKind"
						name="settlementKind"
						[(ngModel)]="filters.settlementKind"
						[multiple]="false"
						[searchable]="false"
					>
						<ng-option *ngFor="let settlementKind of settlementKinds" [value]="settlementKind.id">{{
							settlementKind.name
						}}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="confirmPerson">Osoba odpowiedzialna</label>
					<ng-select id="confirmPerson" name="confirmPerson" [(ngModel)]="filters.confirmPerson">
						<ng-option value="null">(Wszystkie nieprzypisane)</ng-option>
						<ng-option *ngFor="let user of users" [value]="user.id"
							>{{ user.firstName }} {{ user.lastName }}</ng-option
						>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="createBy">Utworzone przez</label>
					<ng-select
						id="createBy"
						name="createBy"
						[(ngModel)]="filters.createBy"
						[multiple]="true"
						[searchable]="true"
					>
						<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
				</div>
			</div>
			<div class="modal-footer">
				<div class="btn-group me-auto">
					<button type="button" class="btn btn-danger" (click)="filtersClear()">Wyczyść</button>
					<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
				</div>
				<div class="btn-group">
					<button type="button" class="btn btn-primary" (click)="filtersSave()">Pokaż</button>
					<button type="button" class="btn btn-secondary" (click)="filtersClose()">Anuluj</button>
				</div>
			</div>
		</div>
	</div>
</div>
